<div class="loading-overlay">
    <div class="branded-spinner-container">
        <div class="spinner-ring"></div>
        <img src="assets/img/static/biworklims.svg" alt="Biwork LIMS Loading" class="spinner-logo">
    </div>
    <h3 class="loading-text">Cargando sistema...</h3>
</div>